export default {
  stats: {
    orders: 'Zamówienia',
    sales: 'Przychody',
  },
};
